import { FC } from 'react';
import { TFunction } from 'i18next';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import {
  getTransactionDetailsDataByType,
  getTransactionDetailsTranslations,
} from '../utils';
import { TransactionDetails } from '../TransactionDetails/TransactionDetails';
import { transactionTypeByTypeName } from '../../transactions/types/transactions';

type TransactionDetailsContentProps = {
  transactionId: string;
  transactionType: (typeof transactionTypeByTypeName)[keyof typeof transactionTypeByTypeName];
  locale: string;
};

const TransactionDetailsContent: FC<TransactionDetailsContentProps> = async ({
  transactionId,
  transactionType,
  locale,
}) => {
  const { t } = await initServerTranslation();

  const isSavingsPlanTransaction =
    transactionType === transactionTypeByTypeName.SavingsPlanTransaction ||
    transactionType ===
      transactionTypeByTypeName.InternalSavingsPlanTransaction;

  const { transaction } = await getTransactionDetailsDataByType({
    id: transactionId,
    type: transactionType,
  });

  const translations = getTransactionDetailsTranslations(t as TFunction);

  return (
    <TransactionDetails
      transaction={transaction as NonNullable<typeof transaction>}
      translations={translations}
      locale={locale}
      translationUtil={t as TFunction}
      showActionButton={!isSavingsPlanTransaction}
    />
  );
};

export { TransactionDetailsContent };
